export default "__VITE_ASSET__CN1SNCbg__"